/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type TierName =
  | 'OPTED_OUT'
  | 'REWARDS_BASE'
  | 'REWARDS_OPTED_OUT'
  | 'SWEETPASS'
  | 'SWEETPASS_PLUS';

export type TierStatusName =
  | 'ACTIVE'
  | 'CANCELLATION_PENDING'
  | 'FREE_TRIAL'
  | 'PAST_DUE'
  | 'PROCESSING';

export type OptInSgRewardsMutationVariables = Exact<{ [key: string]: never }>;

export type OptInSgRewardsMutation = {
  readonly optInFreeTierV2: {
    readonly __typename: 'LoyaltyProfile';
    readonly customerId: string;
    readonly loyaltyId: string | null;
    readonly joinDate: string;
    readonly tier: {
      readonly __typename: 'Tier';
      readonly id: string;
      readonly name: Types.TierName;
      readonly nextTier: {
        readonly __typename: 'Tier';
        readonly id: string;
        readonly name: Types.TierName;
      } | null;
    } | null;
    readonly tierStatus: {
      readonly __typename: 'TierStatus';
      readonly id: string;
      readonly name: Types.TierStatusName;
    } | null;
  } | null;
};

export const OptInSgRewardsDocument = gql`
  mutation OptInSgRewards {
    optInFreeTierV2 {
      __typename
      customerId
      loyaltyId
      joinDate
      tier {
        id
        __typename
        name
        nextTier {
          id
          __typename
          name
        }
      }
      tierStatus {
        id
        __typename
        name
      }
    }
  }
`;

export function useOptInSgRewardsMutation() {
  return Urql.useMutation<OptInSgRewardsMutation, OptInSgRewardsMutationVariables>(
    OptInSgRewardsDocument,
  );
}
